module.exports = __webpack_public_path__ + "static/media/gallivarevapen.82206d7e.png";